import { useMemo } from 'react'
import { Button, ButtonProps } from '@vp/swan'
import { useUploadsStore } from '../../UploadsProvider'
import { usePersonalizationManager } from '../../PersonalizationManager'

type UploadsModalSubmitButtonProps = Omit<ButtonProps, 'ref'> & {
  handleSubmit: () => void
}

export const UploadsModalSubmitButton = (props: UploadsModalSubmitButtonProps) => {
  const { handleSubmit, disabled, ...rest } = props
  const { selectedUploads } = useUploadsStore()

  const { translations } = usePersonalizationManager()
  const { uploadsCopy } = translations

  const applySelectedImagesText = useMemo(() => {
    const numImages = selectedUploads.length

    if (numImages > 1) {
      return uploadsCopy.applyMultipleImages.replace('{{number}}', `${numImages}`)
    }
    if (numImages === 1) {
      return uploadsCopy.applySingleImage
    }
    if (numImages === 0 && !disabled) {
      return uploadsCopy.clearPreview
    }
    return uploadsCopy.genericPreview

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUploads.length])

  return (
    <Button aria-label={applySelectedImagesText} disabled={disabled} skin="primary" width="full-width" onClick={handleSubmit} {...rest}>
      {applySelectedImagesText}
    </Button>
  )
}
